export const apiField = 'client_name';
export default {
  type: 'Text',
  label: 'clientName',
  missing: undefined,
  apiField,
  tooltip: undefined,
};